import type { CmsDataJsonApi } from '@packages/cms-components/interfaces';
import { Banner } from '@packages/cms-components/src/modules/Banner/Banner';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { DynamicYield } from '@packages/shared/src/ui/DynamicYield/DynamicYield';
import { ErrorBoundary } from '@packages/shared/src/ui/ErrorBoundary/ErrorBoundary';

export type CmsTopBannerProps = {
  bannerData: CmsDataJsonApi;
};

/**
 * CmsTopBanner component description displayed in storybook
 * */
export const CmsTopBanner = ({ bannerData }: CmsTopBannerProps) => {
  const { dynamicYieldEnabled } = useConfig();

  return (
    // Tailwind fallback for max-width on img inside rich text
    <div className="[&_img]:max-w-full">
      {dynamicYieldEnabled && (
        <ErrorBoundary>
          {/* mba_topbanner-services */}
          <DynamicYield dataDyId="mba_topbanner-services-desktop" className="hidden md:block" />
          <DynamicYield dataDyId="mba_topbanner-services-mobile" className="md:hidden" />
          {/* mba_campaign-banner */}
          <DynamicYield dataDyId="mba_campaign-banner-desktop" className="hidden md:block" />
          <DynamicYield dataDyId="mba_campaign-banner-mobile" className="md:hidden" />
        </ErrorBoundary>
      )}
      <ErrorBoundary>
        <Banner bannerData={bannerData} />
      </ErrorBoundary>
    </div>
  );
};
